export default __webpack_public_path__ + "static/media/spid-idp-infocertid.bec98f0a.png";